import { render, staticRenderFns } from "./BillingAddressForm.vue?vue&type=template&id=c5e97bdc&scoped=true"
import script from "./BillingAddressForm.vue?vue&type=script&lang=js"
export * from "./BillingAddressForm.vue?vue&type=script&lang=js"
import style0 from "./BillingAddressForm.vue?vue&type=style&index=0&id=c5e97bdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e97bdc",
  null
  
)

export default component.exports